<template>
    <div class="left-side-menu">
        <ul v-if="isOpen">
            <li>
                <button @click="goCart">
                    <router-link :to="{ name: 'Cart' }" class="">
                        <img :src="`/assets/img/sidemenu/cart.svg`" alt="장바구니" />
                    </router-link>
                </button>
            </li>
            <li>
                <button>
                    <router-link to="/mypage/contactus-list">
                        <img :src="`/assets/img/sidemenu/est.svg`" alt="견적문의" />
                    </router-link>
                </button>
            </li>
            <li>
                <button>
                    <router-link to="/helpdesk/index">
                        <img :src="`/assets/img/sidemenu/cstm.svg`" alt="고객센터" />
                    </router-link>
                </button>
            </li>
            <li>
                <button>
                    <router-link to="/mypage/order-list">
                        <img :src="`/assets/img/sidemenu/deli.svg`" alt="출고배송" />
                    </router-link>
                </button>
            </li>
            <li>
                <button>
                    <router-link to="/company/location">
                        <img :src="`/assets/img/sidemenu/way.svg`" alt="오시는길" />
                    </router-link>
                </button>
            </li>
        </ul>

        <img class="btn12" :src="`/assets/img/sidemenu/${isOpen ? 'close' : 'open'}.svg`" alt="접기" @click="toggleSide" />
        <img class="btn12" src="/assets/img/sidemenu/top.svg" alt="top" @click="goTop" />

        <v-navigation-drawer
            class="cart-drawer"
            width="400"
            height="100vh"
            :value="cartDrawerOpen"
            fixed
            temporary
            hide-overlay
            right
            clipped
            @input="updateCartDrawer"
        >
            <cart-for-single :cart-mode="'fixed'" :cart-type="'embed'" />
        </v-navigation-drawer>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import CartForSingle from '../cart/CartForSingle';
    export default {
        components: { CartForSingle },
        computed: {
            ...mapGetters('cart', ['getCartCount', 'getCartAllPrice', 'getTotalCouponDiscount']),
            ...mapGetters('auth', ['cartDrawerOpen']),
        },
        data: () => ({
            isOpen: false,
        }),
        methods: {
            ...mapActions('cart', ['fetchCartProducts']),
            ...mapMutations('auth', ['updateCartDrawer']),

            goTop() {
                window.scrollTo(0, 0);
            },

            goCart() {
                this.$router.push({ name: 'Cart' });
            },
            toggleSide() {
                this.isOpen = !this.isOpen;
            },
        },
        created() {
            this.fetchCartProducts();
            this.path = window.location.pathname;
        },
    };
</script>

<style lang="scss" scoped>
    .left-side-menu {
        position: fixed;
        bottom: 10px;
        right: 10px;
        z-index: 1000;
        width: 100px;
        /* transform: translateY(-50%); */

        ul {
            background: #fff;
            border-radius: 1000px;
            margin: 0;
            padding: 0;
            list-style: none;
            width: 100%;
            padding: 35px 0;
            border: 1px solid #0a2975;

            li {
                margin-bottom: 16px;
                text-align: center;

                &:last-of-type {
                    margin-bottom: 0;
                }

                img {
                    vertical-align: top;
                }
            }
        }

        .btn12 {
            display: block;
            margin: 20px auto 0;
            /* margin-top: 20px; */
            /* text-align: center; */
            vertical-align: top;
            cursor: pointer;
        }
    }
    .cart-drawer {
        z-index: 1000;
    }

    .side-cart-panel {
        z-index: 5;
        position: fixed;
        width: 120px;
        right: 0;
        top: calc(50% - 200px);
        background: #323232;
        color: #fff;
        padding: 0px;
        border-radius: 10px 0 0 10px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    }

    .link-box {
        width: 120px;
        background-color: #fff;
        color: #323232;
        border-bottom: 1px solid #696969;
    }

    .top-box {
        width: 120px;
        background-color: #808080;
        border-radius: 0 0 0 10px;
    }

    .side-cart-panel .link-box :hover {
        color: #fff;
        background-color: #323232;
    }
</style>
